import ContainerCrud from './ContainerCrud'
import enhance from './ContainerCrud.enhancer'

export default enhance(ContainerCrud)



// WEBPACK FOOTER //
// ./src/components/ContainerCrud/index.js